import { DEFAULT_CONFIG } from '../selects';

const SELECTORS = {
    COMPONENT: '.js-location-search',
    FORM: '.js-location-search-form',
    TYPE_SELECT: '.js-location-search-type-select',
    LOCATION_INPUT: '.js-location-search-location-input',
    RESULT_HOLDER: '.js-location-search-locations',
    RESULT_ITEM: '.js-location-search-location',
    MAP_HOLDER: '.js-location-search-map-holder',
    ITEM_TOGGLE: '.js-location-search-item-toggle',
    MORE_INFO: '.js-location-search-more-info',
};

const MODIFIERS = {
    TOGGLE_ACTIVE: 'location-search__locations__item__toggle--active',
    ITEM_ACTIVE: 'location-search__locations__item--active',
    MAP_HOLDER_LOADING: 'is-loading',
};

const SELECT_CONFIG = DEFAULT_CONFIG;

const FETCH_CONFIG = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
};

const MAP_CONFIG = {
    zoom: 9,
    center: { lat: 50.8500, lng: 4.3500 }, // center on Belgium,
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    mapTypeId: 'roadmap',
    gestureHandling: 'cooperative',
};

export { SELECTORS, SELECT_CONFIG, FETCH_CONFIG, MAP_CONFIG, MODIFIERS };
